<div *ngFor="let field of fields.Form.Questions">
  <medpt-field-builder [field]="field" [formInfo]="formInfo" [form]="form" [submitted]="submitted" *ngIf="field.controlVisibled"></medpt-field-builder>
</div>
